// RequireAuth.jsx
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Redirect from '../container/Redirect.js';

import { reduxStoreInitializePromise } from '../resource/reduxStoreInitializePromise.js';

import ChunkLoading from '../component/ChunkLoading.jsx';

export const RequireAuth = ({
  isAuthed,
  token,
  otpToken,
  digestJwtToken,
  children,
}) => {
  const location = useLocation();
  const [isServer, setIsServer] = useState(true);
  const [isReduxStoreInitialized, setIsReduxStoreInitialized] = useState(false);

  useEffect(() => {
    const nextTick = setTimeout(() => setIsServer(false), 0);
    return () => {
      clearTimeout(nextTick);
    };
  }, []);

  useEffect(() => {
    // In Next environment, we render before the redux store retrieve token from IndexedDB,
    // which causes unexpected redirect to /.
    // Since we can't find a way to wait for it by now,
    // we have to ensure that the post-process in redux store has finished to move on.
    reduxStoreInitializePromise.then(() => setIsReduxStoreInitialized(true));
  }, []);

  useEffect(() => {
    if (!isAuthed && token) {
      digestJwtToken({ token });
    }
  }, [digestJwtToken, isAuthed, token]);

  // RequireAuth render might before loadUrlOtpLogin.js
  const searchParams = new URLSearchParams(location.search);
  const otpTokenFromQueryString = searchParams.get('otp');
  if (isAuthed) {
    return children;
  } else if (isServer || !isReduxStoreInitialized) {
    return <ChunkLoading />;
  } else if (token || otpToken || otpTokenFromQueryString) {
    return <ChunkLoading />;
  } else {
    return (
      <Redirect
        to={{
          pathname: '/',
          search: location.search,
        }}
        state={{ from: location }}
      />
    );
  }
};

RequireAuth.propTypes = {
  children: PropTypes.element.isRequired,
  isAuthed: PropTypes.bool.isRequired,
  token: PropTypes.string,
  otpToken: PropTypes.string,
  digestJwtToken: PropTypes.func.isRequired,
};

export default RequireAuth;
